import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class ICompany {
  id: number;
  pointId: number;
  toPoint?: number;
  codeprefix: string;
  yedekparcamnerede_api_key?: string;
  cari?: string;
  bill_manager_user?: string | number;
  userId: string | number;
  entegrasyonUserId?: string | number;
  hidden: number;
  SMS: number;
  EMAIL: string;
  FMAIL3: string;
  FMAIL2: string;
  FMAIL: string;
  payment: number;
  cargo: string;
  pricing_type: string;
  companyType: number;
  autoLoad: string;
  control: string;
  description?: string;
  oldUser?: string | number;
  barkodLock?: number | null;
  barkodLockDesc?: string | null;
}

export class ICompanyResponse {
  @Type(() => ICompany)
  result: ICompany;
}

export class ICompaniesListResponse extends IPagination {
  @Type(() => ICompany)
  results: ICompany[];
}

export class ICompanyQueryDto extends IQueryPaginationDto {
  companyName?: string;
  id?: string;
  companyType?: number;
  codeprefix?: string;
  pointId?: number;
  companyIdNotIn?: (string | number)[];
  hidden?: number;
  collectionRouteId?: number;
}

export class ICompanyPostDto {
  pointId: number;
  toPoint: number | null;
  codeprefix: string;
  userId: number | null;
  hidden: number;
  SMS: number;
  EMAIL: string;
  FMAIL3: string;
  FMAIL2: string;
  FMAIL: string;
  payment: number;
  cargo: string;
  pricing_type: string;
  companyType: number;
  autoLoad: string;
  control: string;
  description: string;
  cari: string | null;
}

export class ICompanyPatchDto {
  pointId?: number;
  toPoint?: number | null;
  codeprefix?: string;
  userId?: number | null;
  hidden?: number;
  SMS?: number;
  EMAIL?: string;
  FMAIL3?: string;
  FMAIL2?: string;
  FMAIL?: string;
  payment?: number;
  cargo?: string;
  pricing_type?: string;
  companyType?: number;
  autoLoad?: string;
  control?: string;
  description?: string;
  cari?: string | null;
  barkodLock?: number | null;
  barkodLockDesc?: string | null;
}
